import * as React from 'react';
const { forwardRef, useState, useCallback } = React;
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import TextField, { TextFieldProps } from '../text-field';
import IconButton from '../icon-button';
import Icon from '../icon';


const useIconButtonStyles = makeStyles((theme) => ({
	iconButton: {
		padding: '6px',
		'&.MuiIconButton-edgeEnd': {
			marginRight: 0
		}
	}
}));

type CopyToClipboardTextFieldProps = {
	appearance: 'default' | 'hidden-text';
	clipboardText?: string;
	setAlwaysValue?: string;
	onCopy?: (value: string) => void;
} & TextFieldProps

const noop = () => {};

const CopyToClipboardTextField = forwardRef<any, CopyToClipboardTextFieldProps>((props, ref) => {
	const {
		appearance,
		clipboardText,
		setAlwaysValue,
		value,
		onCopy,
		onChange,
		...rest
	} = props;
	const isHiddenTextMode = appearance === 'hidden-text';
	const [showValue, setShowValue] = useState(false);
	const classes = useIconButtonStyles({});
	const handleClickShowValue = useCallback(() => setShowValue(v => !v), []);
	const handleChange = useCallback((e: React.SyntheticEvent<any>, value: string) => {
		onChange(e, setAlwaysValue || value);
	}, [setAlwaysValue, onChange]);

	return (
		<TextField
			ref={ref}
			value={value}
			{...rest}
			type={
				isHiddenTextMode
					? showValue ? 'text' : 'password'
					: 'text'
			}
			inputProps={{
				style: {
					textOverflow: 'ellipsis',
				},
			}}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						{
							isHiddenTextMode &&
							<IconButton
								edge='end'
								aria-label='Изменить видимость поля'
								title='Изменить видимость поля'
								className={classes.iconButton}
								onClick={handleClickShowValue}>
								<Icon
									type={showValue ? 'visibility-off' : 'visibility'}
									color='primary'
									width={20}
									height={20}
								/>
							</IconButton>
						}
						<CopyToClipboard
							text={clipboardText || value}
							onCopy={onCopy}>
							<IconButton
								edge='end'
								aria-label='Скопировать в буфер обмена'
								title='Скопировать в буфер обмена'
								className={classes.iconButton}
								onClick={noop}>
								<Icon
									type='file-copy'
									color='primary'
									width={20}
									height={20}
								/>
							</IconButton>
						</CopyToClipboard>
					</InputAdornment>
				),
			}}
			onChange={handleChange}
		/>
	);
});

CopyToClipboardTextField.displayName = 'CopyToClipboardTextField';
CopyToClipboardTextField.defaultProps = {
	appearance: 'default',
	onCopy: () => {},
};

export default CopyToClipboardTextField;
